// src/data/theoryDerivations.js
// Module foundations, built from the ground up. One file per module lives in src/data/foundations/.
// Each step starts from a concrete numerical example and climbs to the module's full theory.
import module1 from './foundations/module-1.js';
import module2 from './foundations/module-2.js';
import module3 from './foundations/module-3.js';
import module4 from './foundations/module-4.js';
import module5 from './foundations/module-5.js';
import module6 from './foundations/module-6.js';
import module7 from './foundations/module-7.js';
import module8 from './foundations/module-8.js';
import module9 from './foundations/module-9.js';
import module10 from './foundations/module-10.js';
import module11 from './foundations/module-11.js';

export const moduleDerivations = {
  'module-1': module1,
  'module-2': module2,
  'module-3': module3,
  'module-4': module4,
  'module-5': module5,
  'module-6': module6,
  'module-7': module7,
  'module-8': module8,
  'module-9': module9,
  'module-10': module10,
  'module-11': module11,
};
